import type { AuditLogEvent } from '../../../domain/audit-log-event'

import { AuditLogAction } from '../../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../../domain/audit-log-resource-type.enum'
import * as constants from '../constants'
import * as utils from '../utils'

interface Props {
  auditLog: AuditLogEvent
}

export const GroupUpdateSummaryColumn = (props: Props): JSX.Element | null => {
  if (
    props.auditLog.resource?.type !== AuditLogResourceType.Group ||
    props.auditLog.action !== AuditLogAction.Update
  ) {
    return null
  }

  const changedFieldNames = (props.auditLog.changes ?? [])
    .filter(diff => !constants.GROUP_UPDATE_EXCLUDED_PATHS.some(path => diff.path.includes(path)))
    .map(diff => utils.renderGroupUpdateHumanFieldName(diff.path[0] as string))

  const uniqueChangedFieldNames = [...new Set(changedFieldNames)]

  return <span>{uniqueChangedFieldNames.join(', ')}</span>
}
